const riot = require('riot');

riot.tag2('page-groups-single', '<div class="container p32"> <h1 class="mb16">{item.data.title}</h1> <div class="mb16"><img riot-src="{item.data.image}"></div> <div><a href="/">TOP</a></div> </div>', 'page-groups-single,[data-is="page-groups-single"]{display:block}', '', function(opts) {
    this.item = {
      data: {}
    };

    this.preload = async ({req, res}) => {
      var ref = db.doc(req.Url.pathname);

      try {
        var ss = await ref.get({source: 'cache'});
      }
      catch(e) {
        if (e.code === 'unavailable') {
          var ss = await ref.get({source: 'server'});
        }
      }

      if (!ss.exists) {
        res.status(404);
        throw 'そのページは存在しません';
      }

      console.log('fromCache:', ss.metadata.fromCache);
      console.log('group name:', ss.data().title);

      var item = {
        id: ss.id,
        ref: ss.ref,
        data: ss.data(),
      };

      return {
        item,
      };
    };

    this.head = () => {
      return {
        title: `${this.item.data.title} | spat`,
        description: '詳細だよー',
        ogp: {
          image: this.item.data.image,
        }
      };
    };

    this.on('show', () => {
      this.item.data.title += ' render client';
    });
});